export default __webpack_public_path__ + "static/media/img4.b6dc51ba.webp";